import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";


export const PrivateRouter = ({ children }) => {
  const {usuario: user}  = useSelector(state=> state.userSlice)

  return user.logged ? children : <Navigate to="/login" />;
};
